import {detect} from 'detect-browser'

export default {
    name: "MenuMixin",
    props: {
        wpMenu: {
            required: true
        }
    },
    computed: {
        currentRoute() {
            return this.$route.path
        },
        isIE10() {
            const browser = detect();
            const version = parseInt(browser.version.substring(0,2));

            return browser.name === 'ie' && version === 10
        },
        menu() {
            let menu = [];
            (this.wpMenu || []).forEach(rootItem => {
                const url = rootItem.url.replace(location.origin, '');
                const filteredTitle = rootItem.title.replace(/(#[0-9]+;)/ig, '');
                const item = {
                    url,
                    id: rootItem.ID,
                    title: filteredTitle,
                    description: rootItem.description,
                    isActive: url === this.currentRoute,
                    external: rootItem.external,
                    forceRegularLink: rootItem.makeRegularLink
                };
                menu.push(item);
            });
            return menu;
        }
    }
}